import React, { useEffect } from 'react';
import { Container } from './styled';
import { useParams } from 'react-router-dom';
import VolleyBallStatStore from './store';
import VSRecord from './VSRecord';
import RecentRecord from './RecentMatch';
import TeamRanking from './TeamRanking';
import { toJS } from 'mobx';
import NextMatch from './NextMatch';

const VolleyBallStat = ({ gameData }) => {
  let { id } = useParams();
  const { getAll, data } = VolleyBallStatStore();

  useEffect(() => {
    getAll(id);
  }, []);
  const { loading } = data;

  return (
    <Container>
      {!loading && (
        <>
          {data.record.vsRecord.length > 0 && (
            <VSRecord data={data.record.vsRecord} />
          )}
          <RecentRecord data={data.record} gameData={gameData} />
          <NextMatch gameData={gameData} data={data.record} />
          <TeamRanking data={data.rank} />
        </>
      )}
    </Container>
  );
};

export default VolleyBallStat;
